export const TRANSLATIONS_GU = {
  login: {
    welcome: "સ્વાગત છે",
    username: "વપરાશકર્તા નામ",
    password: "પાસવર્ડ",
    usernamePlaceholder: "નોંધાયેલ ઇમેઇલ / વપરાશકર્તા નામ",
    signIn: "સાઇન ઇન કરો",
    forgotPassword: "પાસવર્ડ ભૂલી ગયા છો",
    noAccount: "ખાતું નથી?",
    registerNow: "અત્યારે નોંધાવો",
    noUsername: "કૃપા કરીને તમારું વપરાશકર્તા નામ દાખલ કરો!",
    noPassword: "કૃપા કરીને તમારો પાસવર્ડ ઇનપુટ કરો!",
  },
  register: {
    newUser: "નવા વપરાશકર્તા",
    registerHere: "અહીં નોંધણી કરો",
    email: "ઈમેલ",
    emailPlaceholder: "તમારું નોંધાયેલ ઇમેઇલ દાખલ કરો",
    mobileNo: "મોબાઈલ નમ્બર",
    createPassword: "પાસવર્ડ બનાવો",
    confirmPassword: "પાસવર્ડની પુષ્ટિ કરો",
    passwordAgain: "ફરીથી પાસવર્ડ લખો",
    mobilePlease: "કૃપા કરીને મોબાઈલ નંબર",
    signUp: "સાઇન અપ કરો",
    alreadyHaveAccount: "પહેલેથી જ એક એકાઉન્ટ છે!",
    signIn: "સાઇન ઇન કરો",
    noMobileNo: "કૃપા કરીને તમારો મોબાઈલ નંબર દાખલ કરો!",
    noEmail: "કૃપા કરીને તમારું ઇમેઇલ ઇનપુટ કરો!",
    noPassword: "કૃપા કરીને તમારો પાસવર્ડ દાખલ કરો!",
    noConfirmPassword: "કૃપા કરીને તમારો કન્ફર્મ પાસવર્ડ ઇનપુટ કરો!",
  },
  verify: {
    title: "OTP વડે ચકાસો",
    otpOn: "અમે પર એક OTP મોકલ્યો છે",
    registeredEmail: "અને તમારું નોંધાયેલ ઈમેલ સરનામું",
    codeNotReceived: "મને કોડ મળ્યો નથી.",
    resend: "ફરી મોકલો",
    itOr: "તે અથવા",
    details: "વિગતો",
    changeRegistrationDetails: "નોંધણી વિગતો બદલો",
    verify: "ચકાસો",
  },
};
